import { motion } from "framer-motion";
import {
  BrainCircuit,
  GraduationCap,
  ShieldCheck,
  BarChart3,
} from "lucide-react";

const features = [
  {
    icon: BrainCircuit,
    title: "AI Learning Assistant",
    desc: "Smart recommendations based on learner progress.",
  },
  {
    icon: GraduationCap,
    title: "Certification",
    desc: "Digital certification after completing courses.",
  },
  {
    icon: ShieldCheck,
    title: "Enterprise Ready",
    desc: "Secure and scalable for organizations.",
  },
  {
    icon: BarChart3,
    title: "Learning Analytics",
    desc: "Comprehensive dashboard and reporting.",
  },
];

export default function Features() {
  return (
    <section className="bg-slate-950 py-24">

      <div className="container mx-auto px-6">

        <div className="text-center mb-16">

          <h2 className="text-5xl font-bold text-white">

            Why Choose Our Platform

          </h2>

          <p className="text-slate-400 mt-5">

            Built for modern organizations.

          </p>

        </div>

        <div className="grid lg:grid-cols-4 gap-8">

          {features.map((item, index) => {
            const Icon = item.icon;

            return (
              <motion.div
                key={index}
                whileHover={{
                  y: -8,
                }}
                className="rounded-3xl border border-white/10 bg-slate-900 p-8"
              >
                <div className="w-14 h-14 rounded-xl bg-cyan-500/10 flex items-center justify-center text-cyan-400">

                  <Icon size={28} />

                </div>

                <h3 className="text-xl font-bold text-white mt-6">

                  {item.title}

                </h3>

                <p className="text-slate-400 mt-4 leading-7">

                  {item.desc}

                </p>

              </motion.div>
            );
          })}

        </div>

      </div>

    </section>
  );
}